import styled from 'styled-components'

import Toggle from './Toggle'
import Menu from './Menu'

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;

  ${Toggle} {
    width: 100%;
  }

  ${Toggle}::after {
    transform: rotate(${props => (props.direction === 'up' ? 180 : 0)}deg);
  }

  ${Menu} {
    position: absolute;
    min-width: 100%;
    ${props => (props.direction === 'up' ? 'bottom' : 'top')}: 100%;
    display: ${props => (props.show ? 'block' : 'none')};
    border-top-width: 0;
  }
`

export default DropdownContainer
